import * as HLF from "html-living-framework";
import { PowerupData } from "../Data/PowerupData";
import * as Topics from "../Data/Topics";
import { ParallaxLayer } from "../GameObjects/ParallaxLayer";
import { Powerup } from "../GameObjects/Powerup";

export class PowerupLayer extends ParallaxLayer {
    public init(pSize: PIXI.Point): void {
        this._size.copy(pSize);
    }

    protected spawnNewElement(): void {
        const powerup: Powerup = this.getPowerup();
        let powerupData: PowerupData;
        do {
            powerupData = HLF.ArrayUtils.random(this._spawnableElements as PowerupData[]);
        } while (
            this._spawnableElements.length > 1 &&
            this.rightElement !== undefined &&
            powerupData === this.rightElement.data
        );
        powerup.init(powerupData);
        powerup.position.set(this.rightEdge, this._size.y * 0.5 - HLF.Random.floatBetweenPoint(this._yRange));
        this.addChild(powerup);
        powerup.updateTransform();
        this._elements.push(powerup);
        PubSub.publishSync(Topics.CHECK_POWERUP_OVERLAP, powerup);
    }

    protected getPowerup(): Powerup {
        if (this._pool.length === 0) {
            this._pool.push(new Powerup());
        }
        return (this._pool.pop()! as Powerup);
    }
}
